import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { endpoints, asset } from "@/lib/api";
import { PageHeader, CTASection } from "@/components/site/Bits";
import { Reveal } from "@/lib/motion";

export default function EventTypesIndex() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    endpoints.eventTypes().then(setItems).catch(() => {});
  }, []);

  return (
    <div data-testid="event-types-page">
      <PageHeader
        eyebrow="Occasions"
        title={["An experience", "for every room."]}
        intro="From black-tie galas to garden weddings, each occasion is composed with its own considerations. Explore how ARIA is tailored to yours."
        testid="event-types-header"
      />

      <section className="aria-container pb-28 md:pb-40">
        <div className="flex flex-col">
          {items.map((et, i) => (
            <Reveal key={et.id}>
              <Link
                to={`/event-types/${et.slug}`}
                data-testid={`event-type-row-${et.slug}`}
                className="group grid grid-cols-1 items-center gap-6 border-t border-aria-travertine py-8 md:grid-cols-12 md:py-10"
              >
                <div className="md:col-span-1 font-accent italic text-2xl text-aria-brass/60">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="md:col-span-5">
                  <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-none text-aria-ink transition-colors group-hover:text-aria-cocoa">
                    {et.name}
                  </h2>
                </div>
                <div className="md:col-span-4">
                  <p className="font-light text-aria-muted">{et.tagline}</p>
                </div>
                <div className="relative hidden md:col-span-2 md:block">
                  <div className="ml-auto h-24 w-40 overflow-hidden opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                    <img src={asset(et.hero_image)} alt={et.name} loading="lazy" className="h-full w-full object-cover" />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
          <div className="border-t border-aria-travertine" />
        </div>
      </section>

      <CTASection />
    </div>
  );
}
